module.exports = __webpack_public_path__ + "img/FZLC_5.b8a045db.jpg";